/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shoot_Share_Connect_Or_Sell_AnyInputs */

const en_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Sell Anything in Seconds`)
};

const es_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Vende cualquier cosa en segundos`)
};

const fr_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Vendez n'importe quoi en quelques secondes`)
};

const de_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Verkaufe alles in Sekunden`)
};

const ja_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | あらゆるものを数秒で販売`)
};

const zh_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | 几秒钟内出售任何东西`)
};

const ar_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | بِع أي شيء في ثوانٍ`)
};

const id_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Jual Apa Saja dalam Hitungan Detik`)
};

const it_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Vendi Qualsiasi Cosa in Pochi Secondi`)
};

const ru_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Продайте что угодно за секунды`)
};

const pt_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Venda Qualquer Coisa em Segundos`)
};

const ko_shoot_share_connect_or_sell_any = /** @type {(inputs: Shoot_Share_Connect_Or_Sell_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | 몇 초 만에 무엇이든 판매하세요`)
};

/**
* | output |
* | --- |
* | "Shoot Share Connect \| Sell Anything in Seconds" |
*
* @param {Shoot_Share_Connect_Or_Sell_AnyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shoot_share_connect_or_sell_any = /** @type {((inputs?: Shoot_Share_Connect_Or_Sell_AnyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shoot_Share_Connect_Or_Sell_AnyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shoot_share_connect_or_sell_any(inputs)
	if (locale === "es") return es_shoot_share_connect_or_sell_any(inputs)
	if (locale === "fr") return fr_shoot_share_connect_or_sell_any(inputs)
	if (locale === "de") return de_shoot_share_connect_or_sell_any(inputs)
	if (locale === "ja") return ja_shoot_share_connect_or_sell_any(inputs)
	if (locale === "zh") return zh_shoot_share_connect_or_sell_any(inputs)
	if (locale === "ar") return ar_shoot_share_connect_or_sell_any(inputs)
	if (locale === "id") return id_shoot_share_connect_or_sell_any(inputs)
	if (locale === "it") return it_shoot_share_connect_or_sell_any(inputs)
	if (locale === "ru") return ru_shoot_share_connect_or_sell_any(inputs)
	if (locale === "pt") return pt_shoot_share_connect_or_sell_any(inputs)
	return ko_shoot_share_connect_or_sell_any(inputs)
});